import { Button, Flex } from "@fluentui/react-northstar";
import { SurveyDTO, SurveyResponsesDTO } from "@teams/types/api";
import React from "react";

import { TeamsLoader } from "../../../../../_shared/components/TeamsLoader";
import { QuestionVoteField } from "../QuestionVoteField";
import { IcebreakerPreviewResponses } from "./IcebreakerPreviewResponses";

type IcebreakerSurveyCardBodyProps = {
  survey: SurveyDTO;
  hasLoadedResponses: boolean | undefined;
  surveyResponses: SurveyResponsesDTO;
  isSideBar: boolean | undefined;
  onViewResults?: (survey: SurveyDTO, responses: SurveyResponsesDTO) => void;
};

export const IcebreakerSurveyCardBody: React.FC<IcebreakerSurveyCardBodyProps> = ({
  survey,
  hasLoadedResponses,
  surveyResponses,
  isSideBar,
  onViewResults,
}) => {
  const showResultsDetailsButton =
    onViewResults && (!isSideBar || surveyResponses.responses.length > 0);

  return (
    <Flex column gap="gap.small">
      {survey.state !== "pending" && (
        <TeamsLoader isLoading={!hasLoadedResponses}>
          <Flex column gap="gap.small">
            <IcebreakerPreviewResponses
              survey={survey}
              responses={surveyResponses.responses}
              totalResponses={surveyResponses.responses.length}
            />

            {showResultsDetailsButton && (
              <Button
                secondary
                fluid
                size="medium"
                content="Result Details"
                onClick={() => onViewResults(survey, surveyResponses)}
              />
            )}
          </Flex>
        </TeamsLoader>
      )}
      {survey.state === "pending" && <QuestionVoteField question={survey.questions[0]} />}
    </Flex>
  );
};
